import controller from 'fc-ctrl-environment'
import create from 'fc-decoder-environment'

// Libs
import createReducer from 'fc-utils/createReducer'

// Initial State
import initialState from './initialState'

// Constants
import {
  BRANCH,
} from './constants'

import {
  PROP_KEY,
} from 'fc-model-environment'

function optimisticReducer (state, { model }) {
  if (!model[PROP_KEY]) {
    return state
  }

  return {
    ...state,
    [BRANCH]: {
      ...state[BRANCH],
      [model[PROP_KEY]]: create(model),
    },
  }
}

export const reducerMap = {
  ...controller.reducers,
  [controller.actionTypes.update()]: optimisticReducer,
  [controller.actionTypes.create()]: optimisticReducer,
}

// Export
export default createReducer(initialState, reducerMap)
